import { lazy } from "react";

export const LandingHeaderAsync = lazy(() => import("./LandingHeader"));
